let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4xZ5N"), load("e52Rm"), load("1KyrT"), load("9QyoN")]).then(() => parcelRequire('bm1ob'));